module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "products-scroller d-flex align-items-center bg-light py-3"
  }, [_c('span', {
    staticClass: "track-left",
    on: {
      "click": _vm.scrollLeft
    }
  }, [_c('span', {
    staticClass: "ico-arrow-left larger"
  })]), _vm._v(" "), _c('div', {
    staticClass: "track relative"
  }, [_c('ul', {
    ref: "scroller",
    staticClass: "relative d-flex",
    attrs: {
      "id": "scroller-list"
    }
  }, [_c('li', {
    class: {
      selected: (_vm.selected === null)
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('img', {
    staticClass: "all",
    attrs: {
      "src": "/static/images/product_all.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title bold"
  }, [_vm._v("See All")])]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('li', {
      class: {
        selected: (_vm.selected === category.id)
      },
      on: {
        "click": function($event) {
          return _vm.toggleSelection($event, category)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }), _vm._v(" "), _c('div', {
      staticClass: "title bold"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("ellipsis")(category.name, 19)) + "\n                ")])])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "ml-auto track-right",
    on: {
      "click": _vm.scrollRight
    }
  }, [_c('span', {
    staticClass: "ico-arrow-right larger"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4dd30ec0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dd30ec0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/ProductsScroller.vue
// module id = 1674
// module chunks = 0